import { createRESTStore } from "@stores/shared/createRESTStore";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";
import useAssetTreeStore from "@stores/client/useAssetTreeStore";
import useAssetStore from "@stores/client/useAssetStore";

const useBookmarkStore = createRESTStore({
  entityName: "bookmarks",
  apiPaths: {
    update: API.BASE,
  },
  initialState: null,
  additionalActions: (set, get) => ({
    toggleBookmark: async ({ itemType, itemId, assetPath, checked }) => {
      const endpoint = API.FRONTEND[itemType?.toUpperCase()];

      if (!endpoint) {
        throw new Error(`Unsupported bookmark item type: ${itemType}`);
      }

      const nextChecked = !checked;
      set({ updating: true });

      try {
        await apiClient(`${API.BASE}${endpoint}/${itemId}/toggle-bookmark`, {
          method: "PUT",
        });

        if (itemType === "assets" && assetPath) {
          const { setFavNodes } = useAssetTreeStore.getState();
          const { updateItemFavourite } = useAssetStore.getState();
          setFavNodes(assetPath, nextChecked);
          updateItemFavourite(assetPath, nextChecked);
        }

        set({ updating: false });
        return nextChecked;
      } catch (error) {
        set({ updating: false });
        throw error;
      }
    },
  }),
});

export default useBookmarkStore;
